import PropTypes from 'prop-types';
import React from 'react';
import { getLicenceIconsSrc } from './util/dashboardCardHelpers';

var CopyrightComponent = function CopyrightComponent(_ref) {
  var licence = _ref.licence,
      licenceCode = _ref.licenceCode,
      licenceTooltip = _ref.licenceTooltip;
  return /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__title-date-copyright__date-copyright__copyright"
  }, licenceCode ? /*#__PURE__*/React.createElement("i", {
    className: "CreativeCommonsBadge-v2 isSmall js-tooltip ".concat(licenceCode),
    "data-placement": "left",
    title: licenceTooltip,
    "data-original-title": licenceTooltip
  }) : /*#__PURE__*/React.createElement("img", {
    className: "dashboard-card__title-date-copyright__date-copyright__copyright__image",
    src: getLicenceIconsSrc(licence),
    alt: "Licence"
  }));
};

CopyrightComponent.displayName = "CopyrightComponent";
CopyrightComponent.propTypes = {
  licenceCode: PropTypes.string,
  licence: PropTypes.string,
  licenceTooltip: PropTypes.string
};
export default CopyrightComponent;